import type { CloudpackClient } from '@ms-cloudpack/api-server/browser';
import { createContext, type FunctionComponent } from 'preact';
import type { PropsWithChildren } from 'preact/compat';
import { useContext } from 'preact/hooks';

export const CloudpackContext = createContext<CloudpackClient>(null as unknown as CloudpackClient);

export const CloudpackProvider: FunctionComponent<PropsWithChildren<{ client: CloudpackClient }>> = (props) => {
  const { client, children } = props;
  return <CloudpackContext.Provider value={client}>{children}</CloudpackContext.Provider>;
};

export const useCloudpack = (): CloudpackClient => useContext(CloudpackContext);
